module.exports = __webpack_public_path__ + "img/payment.400e3c08.svg";